
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import AuthBackground from "../components/ReuseableCompos/AuthBackground";
import ForgotPassword from "../components/ReuseableCompos/AuthModal/ForgotPassword";
import SEO from '../components/Seo';
const ForgotPasswordPage = () => {
    const { t } = useTranslation("common");
    return (<>
      <SEO title={t("reset_password")} description={t("reset_password_description")}/>
      <AuthBackground />
      <section className="container d-flex align-items-center pt-7 pb-3 pb-md-4" style={{ flex: "1 0 auto" }}>
        <div className="w-100 pt-3">
          <div className="row">
            <div className="col-lg-4 col-md-6 offset-lg-1">
              <div className="view show" id="signin-view">
                <ForgotPassword fromPage={true}/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>);
};
export default ForgotPasswordPage;

    async function __Next_Translate__getStaticProps__1a13f66bdc3__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/forgot-password',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66bdc3__ as getStaticProps }
  